
const routes = [
  { path: '/', component: () => import('pages/new_client.vue') },
  { path: '/trial', component: () => import('pages/new_client_trial.vue') },
  { path: '/apcd', component: () => import('pages/new_client_apcd.vue') },
  { path: '/crors', component: () => import('pages/new_client_crors.vue') },
  { path: '/searchplan', component: () => import('pages/apcd_search_plan.vue') },
  { path: '/crorstrial', component: () => import('pages/new_client_crors_trial.vue') },
  { path: '/apcdtrial', component: () => import('pages/new_client_apcd_trial.vue') },
]

// Always leave this as last one
if (process.env.MODE !== 'ssr') {
  routes.push({
    path: '*',
    component: () => import('pages/Error404.vue')
  })
}

export default routes
